module.exports = __webpack_public_path__ + "img/dropdown-toggle-16x16.933338e4.svg";